import React, { Fragment, useEffect, useState } from 'react';

import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import ExportTableExcel from 'components/Tvendo/Common/ExportTable';

import {
  styleTable,
  bgPurple,
  bgEmerald,
  // bgYellow,
  bgCobert,
  bgOrange,
  deppOrange,
  bgPlomo
} from '../../../Tableconstants/tableConstans.js';
import { wsGetAll } from 'services/WService.js';
import { nInt, nPercent, nCurrency } from 'hooks/Pipe.js';

export default function AdvanceNew(props) {
  const { idIncentive } = props;
  const [advance, setAdvance] = useState({
    incentive: {},
    // zone: {},
    sellers: [],
    providers: [],
    categories: [],
    // data: { summary: [], category: [] }
  });

  async function listAdvances() {
    let response = await wsGetAll(`com/incentive/${idIncentive}/goal`);
    if (response.success) {
      /* const providers = response.data.providers.map((item) => {
        return {
          ...item,
          columns: [
            { label: 'Soles', num: 4, items: ['Cuota', 'Avance', 'Obj_Diario', '%'] },
            { label: 'Cobertura', num: 3, items: ['Cuota', 'Avance', '%'] }
          ]
        };
      }); */
      /* console.log({
        ...response.data,
        providers,
        _cant_providers: response.data?.providers?.length,
        _cant_categories: response.data?.categories?.length
      }) */
      setAdvance({
        ...response.data,
        /* providers, */
        _cant_providers: response.data?.providers?.length,
        _cant_categories: response.data?.categories?.length
      });
    }
  }

  const coberagesProviders = [
    { label: 'Soles', num: 4, items: ['Cuota', 'Avance', 'Obj_Diario', '%'] },
    { label: 'Cobertura', num: 3, items: ['Cuota', 'Avance', '%'] }
  ];

  useEffect(() => {
    listAdvances();
  }, []);

  return (
    <Fragment>
      <CardBody>
        <div style={{ overflow: 'auto' }}>
          <table
            id="table-incentive"
            border="1"
            width="100%"
            cellPadding="2"
            cellSpacing="0"
            style={{ ...styleTable, minWidth: 'auto' }}
          >
            <thead>
              <tr>
                <th
                  rowSpan="4"
                  style={{minWidth: '350px', padding: '15px'}}
                >
                  {`Incentivo ${advance.incentive.period} - ${advance.incentive.CardName} - ${advance.incentive.base_zone_description}`}
                </th>

                <th colSpan={(advance.providers.filter(provider => provider.incentive_type === 'M').length) * 7} style={bgEmerald}>
                  Resumen
                </th>

                {/* Proveedores Masivos */}
                {advance.providers.map((provider, index) => {
                  return (
                    <th key={index} colSpan={provider.categories_count * 8} style={bgPurple}>
                      {provider.description}
                    </th>
                  );
                })}
              </tr>

              {/**
               * 2do Nivel Cabecera
               */}
              <tr>
                {/* Proveedores */}
                {advance.providers.filter(provider => provider.incentive_type === 'M').map(providerGroup => (
                  <th key={providerGroup.id} colSpan="7" style={deppOrange}>{providerGroup.description}</th>
                ))}

                {/* Categorias */}
                {advance.categories.map(category => {
                  return (
                    <th key={category.id} colSpan="8" style={bgPurple}>
                      {`(${category.item_code}) ${category.item_description}`}
                    </th>
                  );
                })}

              </tr>

              {/**
               * 3er Nivel Cabecera
               */}
              <tr>
                {/* Proveedores */}
                {advance.providers.filter(provider => provider.incentive_type === 'M').map((prov) => {
                  const items = coberagesProviders.map((item, i) => (
                    <th key={i} colSpan={item.num} style={bgOrange}>
                      {item.label}
                    </th>
                  ));
                  return items;
                })}

                {advance.categories.map((category, i) => {
                  return (
                    <Fragment key={i}>
                      <th colSpan={4} style={bgOrange}>Volumen soles</th>
                      <th colSpan={4} style={bgOrange}>Cobertura</th>
                    </Fragment>
                  );
                })}
              </tr>

              {/**
               * 4to Nivel Cabecera
               */}
              <tr>
                {advance.providers.filter(provider => provider.incentive_type === 'M').map(() => {
                  const items = coberagesProviders.map((cbProv) => {
                    const val = cbProv.items.map((item, index) => (
                      <th key={index} style={{...bgPlomo, minWidth: '80px'}}>
                        {item}
                      </th>
                    ));
                    return val;
                  });
                  return items;
                })}

                {advance.categories.map((category, i) => {
                  return (
                    <Fragment key={i}>
                      <th style={{...bgPlomo, minWidth: '80px'}}>Objetivo</th>
                      <th style={{...bgPlomo, minWidth: '80px'}}>Avance</th>
                      <th style={{...bgPlomo, minWidth: '80px'}}>%</th>
                      <th style={{...bgOrange, minWidth: '80px'}}>Premio</th>
                      <th style={{...bgPlomo, minWidth: '80px'}}>Objetivo</th>
                      <th style={{...bgPlomo, minWidth: '80px'}}>Avance</th>
                      <th style={{...bgPlomo, minWidth: '80px'}}>%</th>
                      <th style={{...bgOrange, minWidth: '80px'}}>Premio</th>
                    </Fragment>
                  );
                })}
                
              </tr>
            </thead>

            <tbody>
              {/* Premios Minorista */}
              <RewardsRow
                canal={{id: 1, description: 'Minorista'}}
                advance={advance}
              />
                
              {advance.sellers.filter(seller => parseInt(seller.base_canal_id) === 1).map((seller, index) => mapSellerGoals(seller, index, advance))}

              {/* Premios Mayorista */}
              <RewardsRow
                canal={{id: 2, description: 'Mayorista'}}
                advance={advance}
              />

              {advance.sellers.filter(seller => parseInt(seller.base_canal_id) === 2).map((seller, index) => mapSellerGoals(seller, index, advance))}

            </tbody>
          </table>
        </div>
      </CardBody>
      <CardFooter>
        <ExportTableExcel nameFile="abril-2022" idTable="table-incentive" />
      </CardFooter>
    </Fragment>
  );
}

function RewardsRow(props) {
  const { canal, advance } = props;
  return (
    <tr>
      <td style={bgCobert}>{canal.description}</td>
      <td style={bgCobert} colSpan={advance.providers.filter(provider => provider.incentive_type === 'M').length * 7}>
      {canal.description}
      </td>

      {advance.categories.map(category => {
        let volumeReward = category.rewards.find(reward => {
          return parseInt(reward.base_canal_id) === canal.id && reward.indicator_type === 'V';
        });

        let coverageReward = category.rewards.find(reward => {
          return parseInt(reward.base_canal_id) === canal.id && reward.indicator_type === 'C';
        });

        return (
          <Fragment key={category.id}>
            <td style={bgCobert} colSpan={3}></td>
            <td style={bgOrange}>{ nCurrency(volumeReward?.reward, '-') }</td>
            <td style={bgCobert} colSpan={3}></td>
            <td style={bgOrange}>{ nCurrency(coverageReward?.reward, '-') }</td>
          </Fragment>
        );
      })}
    </tr>
  );
}


function mapSellerGoals(seller, index, advance) {
  return (
    <tr key={index}>
      <td>{seller.SlpName}</td>

      {/* Resumen - Summary */}
      {advance.providers.filter(provider => provider.incentive_type === 'M').map(provider => {
        let summaryData = seller.summary.filter(data => parseInt(data.com_incentive_provider_id) === provider.id);
        let volume = summaryData.find(data => data.indicator_type === 'V');
        let coverage = summaryData.find(data => data.indicator_type === 'C');

        return (
          <Fragment key={provider.id}>

            {/*
              Soles (volumen)
              - Cuota
              - Avance
              - Objetivo diario
              - Porcentaje de avance
            */}
            <td align='center'>{ nCurrency(volume?.cuota_mensual, '-') }</td>
            <td align='center'>{ nCurrency(volume?.avance_mensual) }</td>
            <td align='center'>{ nCurrency(volume?.cuota_diaria, '-') }</td>
            <td align='center'>{ nPercent(volume?.porcentaje_avance_mensual) }</td>

            {/*
              Cobertura
              - Cuota
              - Avance
              - Porcentaje
            */}
            <td align='center'>{ nInt(coverage?.cuota_mensual, '-') }</td>
            <td align='center'>{ nInt(coverage?.avance_mensual) }</td>
            <td align='center'>{ nPercent(coverage?.porcentaje_avance_mensual) }</td>

          </Fragment>
        );
      })}

      {/* Data categorias / Focalizado */}
      {advance.categories.map((category) => {
        let categoryGoals = seller.category.filter(sCategory => parseInt(sCategory.com_incentive_category_id) === category.id);

        let volume = categoryGoals.find(goal => goal.indicator_type === 'V');
        let coverage = categoryGoals.find(goal => goal.indicator_type === 'C');

        return (
          <Fragment key={category.id}>
            {/*
              Volumen
              - Objetivo
              - Avance
              - %
              - Premio
            */}
            <td align="center">{ nCurrency(volume?.cuota_mensual, '-') }</td>
            <td align="center">{ nCurrency(volume?.avance_mensual) }</td>
            <td align="center">{ nPercent(volume?.porcentaje_avance_mensual) }</td>
            <td align="center" style={{ minWidth: '80px' }}>{ nCurrency(volume?.reward) }</td>

            {/*
              Cobertura
              - Objetivo
              - Avance
              - %
              - Premio
            */}
            <td align="center">{ nInt(coverage?.cuota_mensual, '-') }</td>
            <td align="center">{ nInt(coverage?.avance_mensual) }</td>
            <td align="center">{ nPercent(coverage?.cuota_mensual, '-') }</td>
            <td align="center" style={{ minWidth: '80px' }}>{ nCurrency(coverage?.reward) }</td>
          </Fragment>
        );
      })}
    </tr>
  );
}
